import React, { Component } from 'react';
import Autosuggest from 'react-autosuggest';
import '../CompanyAutoComplete.css';

class BoxAutocomplete extends Component {
  constructor(props) {
    super(props);
    const searchTerm = props.searchTerm || '';
    this.state = {
      searchTerm,
      suggestions: this.filternumbers(searchTerm),
    };
  }

  componentDidUpdate(prevProps) {
    if (this.props.searchTerm !== prevProps.searchTerm) {
      this.setState({ searchTerm: this.props.searchTerm || '' });
    }
  }

  filternumbers = value => {
    const inputValue = value.trim().toLowerCase();
    const { numbers } = this.props;
    return numbers.filter(number => {
      return number.number.toLowerCase().includes(inputValue);
    });
  };

  getNumberValue = number => number.number;

  renderSuggestion = number => <div>{number.number}</div>;

  onChange = (event, { newValue }) => {
    if (newValue === '') {
      this.props.onChange({ name: 'number', value: null, suggestion: null });
    }
    this.setState({
      searchTerm: newValue,
    });
  };

  // Autosuggest will call this function every time you need to update suggestions.
  // You already implemented this logic above, so just use it.
  onSuggestionsFetchRequested = ({ value }) => {
    this.setState({
      suggestions: this.filternumbers(value),
    });
  };

  // Autosuggest will call this function every time you need to clear suggestions.
  onSuggestionsClearRequested = () => {
    this.setState({
      suggestions: [],
    });
  };

  onNumberSelected = (ev, { suggestion, suggestionValue }) => {
    const evObj = { name: 'number', value: suggestionValue, suggestion };
    this.props.onChange(evObj);
  };

  onKeyPress = e => {
    if (e.key === 'Enter') {
      const { numbers, userAutocomplete } = this.props;
      let suggestion = numbers.filter(item => item.number === e.currentTarget.value);
      this.props.onChange({
        name: 'number',
        value: e.currentTarget.value,
        suggestion: { ...suggestion[0] },
      });
    }
  };

  onClickHandle = e => {
    const { searchTerm, suggestions } = this.state;

    if (searchTerm) {
      const evObj = { name: 'number', value: searchTerm, suggestion: suggestions[0] };
      this.props.onChange(evObj);
    }
  }

  render() {
    const { searchTerm, suggestions } = this.state;

    // Autosuggest will pass through all these props to the input.
    const inputProps = {
      placeholder: this.props.placeholder || 'Search Number...',
      disabled: this.props.isDisabled || this.props.editStatus,
      value: searchTerm,
      onChange: this.onChange,
      onKeyPress: this.onKeyPress,
      name: 'number',
      requires: 'true',
      type: 'text',
      className: 'form-control',
      onClick: this.onClickHandle,
    };

    // Finally, render it!
    return (
      <div className={this.props.className || 'autocomplete-container'}>
        <Autosuggest
          suggestions={suggestions}
          onSuggestionsFetchRequested={this.onSuggestionsFetchRequested}
          onSuggestionsClearRequested={this.onSuggestionsClearRequested}
          getSuggestionValue={this.getNumberValue}
          renderSuggestion={this.renderSuggestion}
          inputProps={inputProps}
          shouldRenderSuggestions={() => true}
          onSuggestionSelected={this.onNumberSelected}
        />
      </div>
    );
  }
}

export default BoxAutocomplete;